import { styled } from "@mui/material/styles";
import { Box, Stack, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router";

// ----------------------------------------------------------------------

const StyledRoot = styled("div")(({ theme }) => ({
  position: "relative",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundImage: "url(/assets/features/pos/posbg.svg)",
  borderRadius: "24px",
  marginTop: "80px !important",
  margin: theme.spacing(2),
  padding: theme.spacing(6, 2),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "600px",
  [theme.breakpoints.down("sm")]: {
    backgroundImage: "url(/assets/about/aboutBg.svg)",
    marginTop: "70px !important",
    minHeight: "400px",
  },
  [theme.breakpoints.up("md")]: {
    height: 900,
    padding: 0,
    margin: theme.spacing(0, 4),
    marginTop: "90px !important",
  },
}));

const StyledContent = styled("div")(({ theme }) => ({
  textAlign: "center",
  alignItems: "center",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

// ----------------------------------------------------------------------

export default function PosHero() {
  const navigate = useNavigate();

  return (
    <StyledRoot>
      <Box >
        <Box display="grid" gap={4}>
          <StyledContent>
            <Typography
              variant="h2"
              sx={{
                color: "white",
                mb: 3,
                fontWeight: "bold",
                fontSize: {
                  xs: "2rem",
                  sm: "2.5rem",
                  md: "3rem",
                  lg: "3.5rem",
                },
                lineHeight: 1.3,
              }}
            >
              Power Your Restaurant with Egora's <br /> All-in-One POS
            </Typography>

            <img
              src="/assets/features/pos/hero.png"
              alt="hero"
              style={{
                maxWidth: "100%",
                height: "auto",
                margin: "0 auto",
                display: "block",
              }}
            />

            <Stack alignItems="center" mt={4}>
              <Button
                variant="contained"
                onClick={() => navigate("/contact")}
                sx={{
                  minWidth: "200px",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "28px",
                  color: "#F08203",
                  px: 3,
                  py: 1.5,
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                  "&:hover": {
                    backgroundColor: "#FFFFFF",
                    color: "#F08203",
                    boxShadow: "none",
                  },
                }}
              >
                Get Started Now
                <Box
                  sx={{
                    backgroundColor: "#F08203",
                    padding: "8px",
                    borderRadius: "50%",
                    marginLeft: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="/assets/about/arrow1.svg"
                    alt="Arrow"
                    style={{
                      width: "16px",
                      height: "16px",
                    }}
                  />
                </Box>
              </Button>
            </Stack>
          </StyledContent>
        </Box>
      </Box>
    </StyledRoot>
  );
}
